/**
 *
 * CancelledTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.vermillionDark};
    background: ${COLORS.vermillionLight};
    border-color: ${COLORS.vermillion};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
    &&& .MuiChip-icon path {
      fill: ${COLORS.vermillion};
    }
  }
`;

function CancelledTag(props) {
  return <StyledTag label="Cancelled" icon={<PinTripIcon />} {...props} />;
}

export default memo(CancelledTag);
